<template>
  <w-dialog :border="true" closeFree width="552px" @ok="onOk"  top="calc(50vh - 300px)" title="提示" v-model="visible" class="pop-apply">
    <div class="apply-title">请确认审批结果</div>
    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="审批结果" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio label="pass">通过</el-radio>
            <el-radio label="reject">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="comment">
          <el-input type="textarea" v-model="form.comment" :rows='4' maxlength="64" show-word-limit></el-input>
        </el-form-item>
    </el-form>
  </w-dialog>
</template>

<script>
export default {
  name: "popApply",
  components: {},
  data() {
    return {
      visible: false,
      form:{
        type:'pass',
        comment:''
      },
      rules: {
        type: [
            { required: true, message: '请选择审批结果', trigger: 'blur' },
          ],
          comment: [
            { required: false, message: '请填写审批备注', trigger: 'blur' },
          ]
        }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    show(required) {
      this.visible = true
      this.rules.comment[0].required = Boolean(required)
      this.$nextTick(()=>{
        this.form.type = 'pass'
        this.form.comment = ''
      })
    },
    onOk() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('>>',this.form)
          this.$emit('ok', this.form)
          this.visible = false
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
  }
}
}
</script>

<style lang="scss" scoped>
.pop-apply {
  .apply-title{
    font-size: 12px;
    color: #939696;
    text-align: center;
    margin-bottom: 12px;
  }
}
.pop-apply /deep/{
  .el-dialog__header{
    padding: 16px 0 0;
    height: 54px;
    box-sizing: border-box;
  }
  .el-dialog__body{
    padding: 16px 36px 0 32px;
  }
  .el-form-item{
    margin-bottom: 26px;
  }
  .el-dialog__footer{
    padding: 6px 0 16px;
  }
}
</style>
